import { mapGetters } from 'vuex';
import geoMapper from '../../store/mapper/_geoMapper.js';

function convertGeoInfo(data, rentals) {
    var geoInfo = {};
    geoInfo = geoMapper(data, rentals);
    geoInfo.medianListPrice = data.medianListPrice;
    geoInfo.distance = data.distance;
    return geoInfo;
}

export default {
    name: 'mvtSeoLink',
    root: true,
    props: {
        cities: {
            type: Array,
            default() {
                return [];
            },
        },
        zipcodes: {
            type: Array,
            default() {
                return [];
            },
        },
        neighborhoods: {
            type: Array,
            default() {
                return [];
            },
        },
        counties: {
            type: Array,
            default() {
                return [];
            },
        },
        maxCount: {
            type: Number,
            default() {
                return 20;
            },
        },
        showSiteMapLinks: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            showMore: {
                city: false,
                zipcode: false,
                neighborhood: false,
                county: false,
            },
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        linkPrefix() {
            return this.glb.rentals ? this.molang('search.common.homesForRentIn') : '';
        },
        cityLinks() {
            return this.cities.map((city) => {
                return convertGeoInfo(city, this.glb.rentals);
            });
        },
        zipcodeLinks() {
            return this.zipcodes.map((zipcode) => {
                return convertGeoInfo(zipcode, this.glb.rentals);
            });
        },
        countyLinks() {
            return this.counties.map((county) => {
                return convertGeoInfo(county, this.glb.rentals);
            });
        },
        neighborhoodLinks() {
            return this.neighborhoods.map((neighborhood) => {
                return convertGeoInfo(neighborhood, this.glb.rentals);
            });
        },
        sectionVisibility() {
            return (
                (this.cityLinks && this.cityLinks.length) ||
                (this.zipcodeLinks && this.zipcodeLinks.length) ||
                (this.countyLinks && this.countyLinks.length) ||
                (this.neighborhoodLinks && this.neighborhoodLinks.length)
            );
        },
    },
    methods: {
        toggle(val) {
            this.showMore[val] = !this.showMore[val];
        },
        toggleCity() {
            this.toggle('city');
        },
        toggleZipcode() {
            this.toggle('zipcode');
        },
        toggleNeighborhood() {
            this.toggle('neighborhood');
        },
        toggleCounty() {
            this.toggle('county');
        },
    },
};
